//
//
//
//
//
//
//
//
//
//
//
//
//

import { FactoryUtils } from "@/utils/FactoryUtils"    
import tableGrid from '@/components/tableGrid'

export default {
    name: "insuranceIndex",
    data(){
        return {
            dataList:[],    
            title:''           
        }
    },
    components:{
      tableGrid
    },
    created() {
        FactoryUtils.claimsDetail().then(res=>{
          this.dataList = res[this.flagList].claimsList;
          this.title = res[this.flagList].claimsTitle;
          if(this.$route.path == '/claimsText'){
            document.title = this.title
            window.scrollTo(0,0);
          }
        })
        
    },
    computed: {
      flagList() {
        return this.$route.query.pdfFlag || 'claims1'  //默认展示理赔说明
      },
    },
    methods: {
      phoneClick(e){
        // console.log(e.target);
          if(e.target.getAttribute("class") && e.target.getAttribute("class").indexOf('editor_phoneNumber') != -1){
             
              var num= (e.target.innerHTML).replace(/[^0-9]/ig,"");
              // 拨打电话
              if(num){
                 this.openCall(num)
              }
              
          }
      }
    },
    
}
